import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppMenu from "./AppMenu";
import { classNames } from "primereact/utils";
import { Avatar } from "primereact/avatar";

const AppTopbar = (props: any) => {
  const navigate = useNavigate();

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.role || "";

  const userName = userData?.first_name ?? userData?.company_name ?? "";

  // logout functionality
  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <div className="layout-topbar">
        <div className="flex gap-2 md:gap-3 lg:gap-0 layout-topbar-left align-items-center ">
          <div className="topbar-start">
            <button className="ml-0 topbar-menu-button p-link" onClick={props.onMenuButtonClick}>
              <i className="pi pi-bars"></i>
            </button>
          </div>
          <h3 className="mt-0 mb-0 product-name">Nagra Accounting</h3>
        </div>

        <div className="flex layout-topbar-right align-items-center">
          <ul className="layout-topbar-right-items">
            <li
              id="profile"
              className={classNames("profile-item", {
                "active-topmenuitem": props.topbarMenuActive,
              })}
            >
              <span className="mr-1 text-white profile-name" onClick={props.onTopbarItemClick}>
                {userData?.first_name ?? ""} {userData?.last_name ?? ""} {userData?.company_name ?? ""}
              </span>

              <button className="mr-0 p-link justify-content-center" onClick={props.onTopbarItemClick}>
                {!window.cn(userName) ? (
                  <Avatar label={userName.charAt(0).toUpperCase()} style={{ backgroundColor: "#2196F3", color: "#ffffff" }} shape="circle" />
                ) : (
                  <Avatar icon="pi pi-user" style={{ backgroundColor: "#2196F3", color: "#ffffff" }} shape="circle" />
                )}
              </button>

              <ul className="fadeInDown">
                <li role="menuitem">
                  <button className="w-full p-link" onClick={() => navigate("/profile")}>
                    <i className="pi pi-user pi-fw"></i>
                    <span style={{ fontWeight: "500" }}>Profile</span>
                  </button>
                </li>
                <li role="menuitem">
                  <button className="w-full p-link" onClick={() => navigate("/change-password")}>
                    <i className="pi pi-user pi-fw"></i>
                    <span style={{ fontWeight: "500" }}>Change Password</span>
                  </button>
                </li>

                {userRole === "Admin" && (
                  <li role="menuitem">
                    <button className="w-full p-link" onClick={() => navigate("/global-setting")}>
                      <i className="pi pi-user pi-fw"></i>
                      <span style={{ fontWeight: "500" }}>Global Setting</span>
                    </button>
                  </li>
                )}
                <li role="menuitem">
                  <button className="w-full p-link" onClick={logout}>
                    <i className="pi pi-fw pi-sign-out"></i>
                    <span style={{ fontWeight: "500" }}>Logout</span>
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AppTopbar;
